<div class="notifications__panel d-flex flex-column justify-content-start align-items-center">
  <div class="notifications__panel-title d-flex align-items-center py-3">
    <button class="notifications__panel-button" (click)="closeNotifications()">
      <mat-icon>close</mat-icon>
    </button>
    <h4 class="panel-title headline mb-0">Notifications</h4>
  </div>
  @if (notifications().length === 0) {
    <div class="w-100 h-100 d-flex justify-content-center">
      <div class="empty__container py-3">
        <img class="mb-2" src="../../../../../assets/svg/icon_notifications-empty.svg" alt="" />
        <p class="font-weight-bold mb-2">All clear for now</p>
        <p>
          <em
            >New notifications will appear here<br />
            when there's activity in your<br />
            workspaces.</em
          >
        </p>
      </div>
    </div>
  } @else {
    <mat-card appearance="outlined" class="notifications__container mb-4">
      <div class="notifications__container-header d-flex align-items-center justify-content-between px-3">
        <mat-slide-toggle
          class="notifications-toggle"
          (click)="switchNotifications()"
          [disabled]="unreadNotificationsCount() === 0 && isShowingUnreadNotifications()"
        >
          {{ 'Only Unread (' + unreadNotificationsCount() + ')' }}
        </mat-slide-toggle>
        <button mat-stroked-button color="primary" class="mark-all-button" (click)="markAllNotificationsAsRead()">
          Mark all as read
        </button>
      </div>
      <div class="notifications__container-body">
        @for (notification of displayedNotifications(); track notification.id) {
          <div class="notification_card p-3">
            <div class="d-flex notification-link" (click)="onNotificationClick($event, notification)">
              <div class="notification_card-logo-container mr-2">
                <img src="../../../../../assets/images/icons/{{ notification.icon }}" alt="" />
              </div>
              <div class="notification_card-message-container">
                <div class="d-flex justify-content-between mb-1">
                  <p class="font-weight-bold">{{ notification.title }}</p>
                  <div class="d-flex justify-content-center align-items-center">
                    <p>{{ notification.createdOn }}</p>
                    @if (!notification.isRead) {
                      <div class="unread ml-2"></div>
                    }
                  </div>
                </div>
                <p class="message-text">{{ notification.description }}</p>
              </div>
            </div>
          </div>
        }
        <div class="final_card p-3">
          <img class="mb-2" src="../../../../../assets/svg/icon_notifications-end.svg" alt="" />
          <p>
            <em
              >Those are all your notifications from<br />
              the last 30 days.</em
            >
          </p>
        </div>
      </div>
      <div class="notifications__container-footer"></div>
    </mat-card>
  }
</div>
